BasketListController.$inject = ['BasketService', 'BasketConfig'];
export default function BasketListController (BasketService, BasketConfig) {
    var ctrl = this;

    ctrl.hitsList = BasketConfig .hitsList;
    ctrl.maxSize = BasketConfig.maxSize;
    ctrl.sortKeysList = BasketConfig.sortKeysList;
    ctrl.q = {};
    ctrl.q.hits =  ctrl.hitsList[1];
    ctrl.q.sortby =  ctrl.sortKeysList[0];
    ctrl.q.current = 1;

    ctrl.pageChanged = function() {
        var params = {};
        params.startRecord = (ctrl.q.current-1)*ctrl.q.hits.value + 1;
        params.maximumRecords = ctrl.q.hits.value;
        params.sortKeys = ctrl.q.sortby.value;
        BasketService.count().$promise.then(function(response) {
            ctrl.totalCount = response.content;
            BasketService.get(params).$promise.then(function(response) {
                ctrl.content = response;
            }, function(err) {
                ctrl.error = err.message || err;
            });
        }, function(err) {
            ctrl.error = err.message || err;
        });
    };

    ctrl.firstPage = function() {
        ctrl.q.current = 1;
        ctrl.pageChanged();
    };

    ctrl.$onInit = function() {
        ctrl.firstPage();
    }
}
